
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/trust-safety",
      function () {
        return require("private-next-pages/about/trust-safety.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/trust-safety"])
      });
    }
  